export default "__VITE_ASSET__0454e8a6__"